import React from 'react';

const AHardcoverEditor = (props) => {
    return (
        <div>
            {props.children}
            <div className="form-group">
                <label className="col-sm-3 control-label">Kod reklamowy partnera</label>
                <div className="col-sm-9">
                    <input type="text" name="tracking_code" className="form-control" defaultValue={props.settings.tracking_code} placeholder="" />
                </div>
            </div>
        </div>
    );
}


export default AHardcoverEditor;